import { META } from "../../data/reportContent";

export const ReportFooter = () => (
  <footer className="report-footer" data-testid="report-footer">
    <span>{META.title}: {META.subtitle}</span>
    <span>{META.edition} · {META.date}</span>
    <span>{META.provenance}</span>
    <span data-testid="report-copyright">{META.copyright}</span>
  </footer>
);
